import { render, staticRenderFns } from "./Adverts.vue?vue&type=template&id=36cc9f2f"
import script from "./Adverts.vue?vue&type=script&lang=js"
export * from "./Adverts.vue?vue&type=script&lang=js"
import style0 from "./Adverts.vue?vue&type=style&index=0&id=36cc9f2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports